/**
 * Qual host serve o painel da Pharu.
 *
 * O painel não é uma tela do ERP: é outro produto, para outro público (a
 * equipe da Pharu, olhando várias marcenarias). Ele vive em domínio
 * próprio — `painel.pharu.com.br` — e some do domínio do ERP.
 *
 * O que isto NÃO é: controle de segurança. Todo subdomínio emitido aparece
 * nos logs públicos de Certificate Transparency, então quem procura acha.
 * O que protege o painel continua sendo o gate de operador da Pharu + MFA
 * recente + auditoria, tudo no backend. A separação por host é de produto:
 * duas superfícies, dois endereços, sem "tela escondida" dentro do ERP do
 * cliente.
 */

/** O host do painel. Configurável para não amarrar código a um domínio. */
export const HOST_DO_PAINEL = (
  process.env.REACT_APP_PAINEL_HOST || "painel.pharu.com.br"
).toLowerCase();

/** A URL para onde mandar quem chegou pelo endereço antigo. */
export const URL_DO_PAINEL = `https://${HOST_DO_PAINEL}`;

function hostAtual() {
  if (typeof window === "undefined") return "";
  return String(window.location.hostname || "").toLowerCase();
}

/**
 * O navegador está no domínio do painel?
 *
 * Lida em tempo de render, nunca no import: teste e ferramenta trocam o
 * `location` depois que o módulo já carregou.
 */
export function ehHostDoPainel() {
  return hostAtual() === HOST_DO_PAINEL;
}

/**
 * Máquina de desenvolvimento.
 *
 * Em dev não há DNS para `painel.pharu.com.br`, então o painel continua
 * acessível por `/painel` no localhost — senão ninguém consegue trabalhar
 * nele sem mexer no arquivo de hosts do sistema.
 */
export function ehAmbienteLocal() {
  const host = hostAtual();
  return (
    host === "localhost" ||
    host === "127.0.0.1" ||
    host === "[::1]" ||
    host.endsWith(".localhost")
  );
}

/** O painel pode ser servido neste host? */
export function painelDisponivelAqui() {
  return ehHostDoPainel() || ehAmbienteLocal();
}
